import { Card, CardContent, Skeleton } from "@avenue-8/sidekick-ui";

export const ListingCardSkeleton = () => {
  return (
    <Card>
      <Skeleton
        variant="rectangular"
        width="100%"
        height={180}
        animation="wave"
      />

      <CardContent sx={{ padding: "1rem!important" }}>
        <Skeleton variant="text" width="35%" height={32} animation="wave" />
        <Skeleton variant="text" width="90%" height={24} animation="wave" />
        <Skeleton variant="text" width="45%" height={16} animation="wave" />
        <Skeleton variant="text" width="55%" height={16} animation="wave" />
      </CardContent>
    </Card>
  );
};
